/**
 * Filtro do chat (doc 06): roda no servidor e mascara palavrões em pt-BR com asteriscos. Compara
 * **palavras inteiras** (não pedaços: "computador" passa), depois de tirar acentos, trocar números
 * e símbolos comuns por letras (p0rr4) e juntar letras repetidas (porraaa). Lista curta,
 * extensível; separações com espaço ("p o r r a") não são pegas.
 */
const TERMS = [
  "porra",
  "caralho",
  "merda",
  "bosta",
  "puta",
  "putaria",
  "puto",
  "viado",
  "buceta",
  "xoxota",
  "xota",
  "cu",
  "cuzao",
  "fdp",
  "pqp",
  "vsf",
  "tnc",
  "arrombado",
  "arrombada",
  "desgracado",
  "desgracada",
  "foder",
  "foda",
  "fodase",
  "fodido",
  "fodida",
  "piroca",
  "punheta",
  "corno",
  "bicha",
  "traveco",
  "sapatao",
  "retardado",
  "retardada",
];

const LEET: Record<string, string> = { "0": "o", "1": "i", "3": "e", "4": "a", "5": "s", "7": "t", "@": "a", $: "s" };

/** Forma comparável: sem acentos, minúsculas, números/símbolos como letras e sem letras repetidas. */
export function foldWord(word: string): string {
  const plain = word
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[013457@$]/g, (c) => LEET[c] ?? c);
  return plain.replace(/(.)\1+/g, "$1");
}

const BLOCKED = new Set(TERMS.map(foldWord));

/** A palavra (ou o plural dela) é um termo bloqueado? */
export function isProfane(word: string): boolean {
  const f = foldWord(word);
  return BLOCKED.has(f) || (f.length > 2 && f.endsWith("s") && BLOCKED.has(f.slice(0, -1)));
}

/** Troca cada palavrão por asteriscos do mesmo tamanho. */
export function maskProfanity(text: string): string {
  return text.replace(/[\p{L}\p{N}@$]+/gu, (word) => (isProfane(word) ? "*".repeat([...word].length) : word));
}

/**
 * Texto de chat seguro para repassar: NFC, sem caracteres de controle e de formatação, espaços
 * comprimidos e no máximo `max` caracteres (por ponto de código, sem partir emojis).
 */
export function cleanChat(raw: string, max: number): string {
  const cleaned = raw
    .normalize("NFC")
    .replace(/[\p{Cc}\p{Cf}]/gu, " ")
    .replace(/\s+/g, " ")
    .trim();
  return [...cleaned].slice(0, max).join("").trim();
}
